module.exports = __webpack_public_path__ + "static/media/mraBlog2.dcb73652.jpg";